import * as validate from 'yup';

export default validate.object({
  firstname: validate.string()
    .required('Requerido'),
  lastname: validate.string()
    .required('Requerido'),
  email: validate.string()
    .email('Correo electrónico inválido')
    .required('Requerido'),
  city: validate.string()
    .required('Requerido'),
  mobilephone: validate.string()
    .required('Requerido'),
  country: validate.string()
    .required('Requerido'),
});
